import { render, staticRenderFns } from "./BoxItem.vue?vue&type=template&id=16ea14da&scoped=true"
import script from "./BoxItem.vue?vue&type=script&lang=js"
export * from "./BoxItem.vue?vue&type=script&lang=js"
import style0 from "./BoxItem.vue?vue&type=style&index=0&id=16ea14da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ea14da",
  null
  
)

export default component.exports